<template>
  <div
    class="scrollable-container"
    :style="style"
  >
    <slot/>
  </div>
</template>

<script>
export default {
  name: 'ScrollableContainer',
  data () {
    return {
      maxHeight: 0
    }
  },
  computed: {
    style () {
      return {
        maxHeight: this.maxHeight + 'px'
      }
    }
  },
  mounted () {
    this.recalculate()
    window.addEventListener('resize', this.recalculate)
  },
  methods: {
    recalculate () {
      this.maxHeight = window.innerHeight - this.$el.offsetTop
    }
  }
}
</script>

<style scoped>
.scrollable-container {
  width: 100%;
  height: auto;
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/scrollable-container.vue